'use strict';
(() => {
    class BasketToolbar {
        hide: boolean = false;
        basketTotal: number = 0;
        basketCount: number = 0;
        constructor(
            private $scope: ng.IScope,
            private broker)
        {

            $scope.$on('$destroy', () => {
                broker.unsubscribe('basketToolbarDirective');
            });
        }
    }

    angular.module('TR')
        .directive('basketToolbar', ($rootScope: ng.IRootScopeService, broker: any): ng.IDirective => {
            return {
                restrict: 'E',
                controller: BasketToolbar,
                controllerAs: 'bt',
                replace: true,
                templateUrl: 'partials/home/directivetemplate?type=BasketToolbar',
                link: (scope: ng.IScope, el:JQuery, attr:ng.IAttributes, ctrl:BasketToolbar): void => {
                    $rootScope.$on('$routeChangeSuccess', function (_, next) {
                        ctrl.hide = !!next.hideDistractionLinks;
                    });
                }
            };
        });
})();
